import { render, staticRenderFns } from "./viewPhytosanitaryProductPlagueDetail.vue?vue&type=template&id=1b2524dc&"
import script from "./viewPhytosanitaryProductPlagueDetail.vue?vue&type=script&lang=js&"
export * from "./viewPhytosanitaryProductPlagueDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports